import React from 'react';
import PropTypes from 'prop-types';
import keys from 'lodash/keys';
import isEmpty from 'lodash/isEmpty';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withRouter } from 'react-router-dom';

import { faAngleUp, faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import SidebarLink from './sidebar_link';

export class ProjectLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    sideBarLinkComponent: PropTypes.elementType,
    tabs: PropTypes.object.isRequired
  };

  state = {
    activeSuperTabs: keys(this.props.tabs)
  }

  componentDidMount() {
    if (this.props.location.pathname === '/') this.props.history.replace(`/${this.defaultTab()}`);
  }

  toggleSuperTab = (key) => {
    this.setState((state) => {
      const { activeSuperTabs } = state;
      const idx = activeSuperTabs.indexOf(key);
      idx == -1 ? activeSuperTabs.push(key) : activeSuperTabs.splice(idx, 1);
      return { activeSuperTabs };
    });
  }

  firstSubtabForTab(key) {
    const subtabs = this.props.tabs[key].subtabs;
    return keys(subtabs)[0];
  }

  defaultTab() {
    const firstTabContainer = this.props.tabs[this.keysForDisplay()[0]];
    return firstTabContainer.subtabs ? Object.keys(firstTabContainer.subtabs)[0] : firstTabContainer.tab.label;
  }

  linkComponent(tabData, key) {
    const route = tabData.route || key;
    const LinkComponent = this.props.sideBarLinkComponent || SidebarLink;

    return <LinkComponent key={key} name={key} tabData={tabData} to={route} />;
  }

  renderSubtabs(subtabs) {
    const subtabJSX = keys(subtabs).map((subtabKey) => {
      const tabData = subtabs[subtabKey];
      return this.linkComponent(tabData, subtabKey);
    });

    return (
      <div className="sidenav-tab-container">
        {subtabJSX}
      </div>
    );
  }

  keysForDisplay() {
    return keys(this.props.tabs).filter((key) => {
      return !isEmpty(this.props.tabs[key].subtabs) || !isEmpty(this.props.tabs[key].tab);
    });
  }

  renderSideBarSection(key) {
    const onlyOneSection = this.keysForDisplay().length === 1;
    const tab = this.props.tabs[key];

    if (onlyOneSection) {
      return (
        <div className="pb-3 mt-4" key={key}>
          {this.renderSubtabs(tab.subtabs)}
        </div>
      );
    } else if (tab.subtabs && Object.keys(tab.subtabs).length > 0) {
      const sectionIsActive = this.state.activeSuperTabs.includes(key);

      return (
        <React.Fragment key={key}>
          <div
            className="side-tab d-none d-sm-flex align-items-center mt-3 pb-2 text-muted text-uppercase clickable outline-0"
            onClick={() => this.toggleSuperTab(key)}
          >
            <div className="text-muted pe-1">{key}</div>
            <FontAwesomeIcon icon={sectionIsActive ? faAngleUp : faAngleDown}/>
          </div>
          {sectionIsActive && this.renderSubtabs(tab.subtabs)}
        </React.Fragment>
      );
    }

    return (
      <div className="pb-3 mt-4" key={key}>
        {this.linkComponent(tab.tab, key)}
      </div>
    );
  }

  renderSideBar() {
    return (
      <div className="side-navigation px-3">
        {this.keysForDisplay().map(key => this.renderSideBarSection(key))}
      </div>
    );
  }

  render() {
    return (
      <div className="project-navigation" id="projectNavTabs">
        {this.renderSideBar()}

        <div className="project-content overflow-y-auto bg-white flex-grow-1">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default withRouter(ProjectLayout);
